
var API_DOMAIN = "https://mksbilling.zentexus.com/api";


// var API_DOMAIN = "http://localhost/mks_api/api";



export default API_DOMAIN;